/*
|--------------------------------------------------------------------------
| Utilities: Fetch: Bucket
|--------------------------------------------------------------------------
*/
/**
 * Fetch bucket
 * @memberof utilities.fetch
 * @namespace utilities.fetch.bucket
 * @inner
 */
__gh__webApp.utilities.fetch.bucket = {

	/**
	 * Initialize
	 *
	 * @memberof utilities.fetch.bucket
	 * @method init
	 */
	"init": function(){
		this.bindEvents();
		this.loadAllBuckets();
	},

	"fetchJSONCallback": function(data){

		var fetchJSON 				= __gh__webApp.utilities.fetch.json.get,
			webAppBuckets			= __gh__webApp.buckets,
			injectView				= __gh__webApp.utilities.fetch.handlebarsView.after,
			commonJS				= __gh__webApp.common,
			dom						= data.dom,
			bucket					= data.bucket,
			items					= bucket.items,
			jsonData				= ("json" in data) ? data.json : {},
			bucketHasItems			= false;
		

		//Update bucket
		bucket 	= webAppBuckets.updateBucket(bucket,jsonData);

		//Kill bucket check
		if(!bucket){
			return;
		} else {
			bucket.killBucket = false;
		}

		//Load assets
		bucket = webAppBuckets.loadAssets(bucket);

		//Append view to page
		injectView({
			"dom"		: dom,
			"view"		: bucket.view.layout, 
			"data"		: bucket,
			"callback"	: "__gh__webApp.buckets.triggerPostLaydownFunctions"
		});
		

	},

	/**
	 * Load bucket
	 * @memberof utilities.fetch.bucket
	 * @method loadBucket
	 * Fetches the json feeds for the buckets
	 * @param {object} bucket
	 */
	"loadBucket": function(bucket){
		var thisObject		= __gh__webApp.utilities.fetch.bucket,
			webAppBuckets	= __gh__webApp.buckets,
			fetchJSON		= __gh__webApp.utilities.fetch.json.get,
			validateBucket	= __gh__webApp.data.validate.bucket,
			commonJS		= __gh__webApp.common,
			bucket 			= webAppBuckets.hookBeforeBucketHasItems(bucket);
			dom 			= bucket.dom,
			feedURL			= bucket.feedURL,
			callbackData	= {
				"bucket":bucket,
				"dom":dom
			};
			callbacks	= [{
				"callback": "__gh__webApp.utilities.fetch.bucket.fetchJSONCallback",
				"data": callbackData
			}];

			//Fetch content from feed and store in data node
			if(feedURL && !validateBucket.hasItems(bucket)){
				fetchJSON({
					"async"	: true,
					"url"	: feedURL,
					"callbacks": callbacks,
					"errorCallbacks": callbacks
				});
				return;
			}

			thisObject.fetchJSONCallback(callbackData);

	},


	/**
	 * Loads buckets on a page based on the view data object
	 *
	 * @memberof utilities.fetch.bucket
	 * @method loadAllBuckets
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 * @param {string} options.view - view name to use
	 * @param {object} options.data - data for the view
	 * @example
	 * &lt;div id="example" data-gh-fetch-bucket-loaded="false" data-gh-fetch-bucket-object='{"url":"http://example.com/json","view":"viewName","data":"data"}'&gt;&lt;/div&gt;
	 */
	 "loadAllBuckets": function() {
		var fetchBucket = this.loadBucket;

		//Auto load html content
		$("[data-gh-fetch-bucket-loaded=false]").each(function(){
			var $this 			= $(this);
				fetchBucketObject = $this.data("gh-fetch-bucket-object");

			if (!fetchBucketObject.dom){
				fetchBucketObject.dom = $this[0];
			}

			fetchBucket(fetchBucketObject);

			//Only load html once.
			if(!$(this).data("gh-fetch-bucket-loaded")){
				$(this).attr("data-gh-fetch-bucket-loaded",true);
			}


	  	});
	},


	/**
	 * Load a lazy bucket
	 * @memberof utilities.fetch.bucket
	 * @method loadLazyBucket
	 */
	"loadLazyBucket": function(){
		var thisObject 	= __gh__webApp.utilities.fetch.bucket,
			fetchBucket = thisObject.loadBucket,
			$lazyBucket = $("[data-gh-fetch-lazy-bucket-loaded=false]").first(),
			fetchBucketObject;

		//Check to see if is on screen
		if ($lazyBucket && $lazyBucket.length && $lazyBucket.isOnScreen(500)){

	    	fetchBucketObject = $lazyBucket.data("gh-fetch-bucket-object");

	    	if (!fetchBucketObject.dom){
				fetchBucketObject.dom = $lazyBucket[0];
			}

	    	fetchBucket(fetchBucketObject);

			$lazyBucket.attr("data-gh-fetch-lazy-bucket-loaded",true);
	    }
	},


	/**
	 * Bind the UI events
	 *
	 * @memberof utilities.fetch.bucket
	 * @method bindEvents
	 */
	"bindEvents": function() {
		var fetchBucket = this.loadBucket;

	    /*$(document).on("click", "a[data-gh-fetch-bucket-object]", function(event){
		    event.preventDefault();
		    var fetchBucketObject = $(this).data("gh-fetch-bucket-object");
			fetchBucket(fetchBucketObject);
		});*/
	
		$(document).on("scroll.gh-fetch-lazy-buckets",this.loadLazyBucket);

  	}
};
